import moment from 'moment';

const localeDict = {
    'en-US': 'English',
    'es': 'Español',
    'it-IT': 'Italiano',
    'fr-FR': 'Français',
    'pt-PT': 'Português',
    'cs-CZ': 'Czech',
    'ar': 'العربية',
    'he': 'ישראל'
};

const rtlLocateDict = ['he', 'ar'];

export function formatLocale(locale) {
    return localeDict[locale] || 'English';
}

export function isRTL(locale) {
    return locale && rtlLocateDict.indexOf(locale) >= 0;
}

export function generateMomentLocaleSettings(locale) {
    var localeData = moment.localeData('en');
    let response = {
        ordinal: localeData.ordinal()
    };
    return response;
}

export function dateInternationalization(locale) {

    const localeCode = {
        'en-US': 'en',
        'ar': 'ar',
        'es': 'es',
        'fr-FR': 'fr',
        'it-IT': 'it',
        'pt-PT': 'pt',
        'he': 'he'
    };

    if (locale == 'ar') {
        moment.updateLocale('en-US', {
            ...moment.localeData('en-US')._config,
            months: [
                'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
                'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
            ],
            monthsShort: [
                'ينا', 'فبر', 'مار', 'أبر', 'ماي', 'يون',
                'يول', 'أغس', 'سبت', 'أكت', 'نوف', 'ديس'
            ],
            weekdays: [
                'الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء',
                'الخميس', 'الجمعة', 'السبت'
            ],
            weekdaysShort: [
                'أحد', 'اثن', 'ثلث', 'أرب', 'خمي', 'جمع', 'سبت'
            ],
            weekdaysMin: [
                'ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'
            ]
        });
        moment.locale('en-US');
        return moment;
    }
 
    let localeOptions = {};
    if (locale === 'es') {
        localeOptions = {
            weekdaysMin: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']
        };
    }
    moment.updateLocale(localeCode[locale ? locale : 'en-US'], localeOptions);
    moment.locale(localeCode[locale ? locale : 'en-US']);
    return moment;
}






